module.exports = __webpack_public_path__ + "static/media/36-1.19dc2fc5.mp3";